import {Colors} from '@eitje/assets'
import {exists} from '@eitje/utils'
import {Text} from '~/components'
import {formatPercentage} from '../helpers'

export const Delta = ({value, positive, negative, compact, fontSize, weight, bold, style}) => {
	if (!exists(value)) return null

	const displayedValue = compact ? Math.round(value) || 0 : value
	let color = Colors.mediumGrey
	if (value > 0) color = positive
	if (value < 0) color = negative

	let sign = ''
	if (value > 0) sign = '+'
	// Negative displayed values include their minus sign; rounded negative values need one explicitly.
	if (value < 0 && displayedValue === 0) sign = '-'

	return (
		<Text fontSize={fontSize} weight={weight} bold={bold} style={{color, ...style}}>
			{`${sign}${formatPercentage(displayedValue)}`}
		</Text>
	)
}
